import React from 'react';
import PropTypes from 'prop-types';

import PhotoCrop from './PhotoCrop';
import withModal from '../modal/withModal';

export const PHOTO_CROP_MODAL = 'MODAL/PHOTO_CROP';

const propTypes = {
  actionProps: PropTypes.object,
};

const PhotoCropModal = ({ actionProps, ...props }) => {
  const { photoId, identityId } = actionProps ?? {};
  return <PhotoCrop photoId={photoId} identityId={identityId} {...props} />;
};

PhotoCropModal.propTypes = propTypes;

export default withModal(PhotoCropModal, {
  name: PHOTO_CROP_MODAL,
  type: 'full',
  className: 'photo-overlay-viewer',
  hideHeader: true,
});
